import './GameListItem.scss';
import React, {useContext} from 'react';
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";

function GameListItem({data, name}) {
  const {t} = useTranslation();
  const context = useContext(Context);
  name = name.replace(/ /g,'');

  return <div className='game-list-item' onClick={() => context.activeGameID.set(data['id'])}>
    <img className="item-img" src={`${process.env.PUBLIC_URL}./assets/games/${data['name']}.jpg`} alt=""/>
    <div className='item-name'>{t(name).toUpperCase()}</div>
    <div className="item-line"/>
  </div>
}

export default GameListItem;